import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import BannerSlider from "@/components/BannerSlider";
import CountdownStrip from "@/components/CountdownStrip";
import DiwaliIntro from "@/components/DiwaliIntro";
import Gallery from "@/components/Gallery";
import ProductCarousel from "@/components/ProductCarousel";
import Anniversary from "@/components/Anniversary";
import TopSelling from "@/components/TopSelling";
import ValueSection from "@/components/ValueSection";
import DiwaliDays from "@/components/DiwaliDays";
import Celebrities from "@/components/Celebrities";
import FeaturedIn from "@/components/FeaturedIn";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import StickyCTA from "@/components/StickyCTA";
import FloatingDiyas from "@/components/FloatingDiya";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { useStore } from "@/store/StoreContext";

export default function Landing() {
  const { products, content } = useStore();

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("is-visible")),
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [products]);

  return (
    <div className="grain bg-[#FDF8F0] text-[#2B1E12]" data-testid="landing-page">
      <Navbar />
      <BannerSlider />
      <CountdownStrip />
      <DiwaliIntro />
      <ProductCarousel
        id="collection"
        testid="diwali-collection"
        eyebrow={content?.collection_eyebrow || "Diwali 2026 Collection"}
        title={content?.collection_title || "Sacred Gifts for the Festival of"}
        accent={content?.collection_accent || "Lights"}
        subtext={content?.collection_subtext || "Authentic Rudraksha combinations and Dhanteras puja, curated for prosperity, health and harmony."}
        products={products}
      />
      <Anniversary />
      <TopSelling />
      <Gallery />
      <DiwaliDays />
      <ValueSection />
      <Celebrities />
      <FeaturedIn />
      <Footer />
      <CartDrawer />
      <StickyCTA />
      <FloatingDiyas />
      <WhatsAppFloat />
    </div>
  );
}
